export function revealFlashingElements() {
    const elements = ['#sub-menu-desktop', '#sub-menu-mobile', '#add-agent-modal', '#transfer-agent-modal', '#transfer-client-modal', '#agency-modal', '#client-modal','#notifications-area', '#side-menu'];
    elements.forEach(selector => {
        const element = document.querySelector(selector);
        if (element) {
            element.classList.remove('hidden');
        }
    });
}
